import { RoundedButton } from 'components/NewInputs';
import I18n from 'i18n-js';
import { navigate } from 'navigation';
import React from 'react';
import MensajeRecordatorios from 'types/models/mensajes-recordatorios';
import styles from './mensaje-recordatorio-list-row.module.scss';

interface MensajeRecordatorioRowProps {
  solicitud: MensajeRecordatorios;
}

export const MensajeRecordatorioRow = (props: MensajeRecordatorioRowProps): JSX.Element => {
  const { solicitud } = props;
  const { t } = I18n;

  const url = `/tecnic/onboarding/mensajes-recordatorios/${solicitud.id}/detalles`;
  return (
    <tr className={styles.mainrow}>
      <td>{solicitud.pasoNombre}</td>

      <td>
        <RoundedButton
          onClick={() => {
            navigate(url);
          }}
        >
          {t(`ComunitiesEnrolledListPage.detalles`)}
        </RoundedButton>
      </td>
    </tr>
  );
};
